/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  SET_LOADING_SPINNER = '[Shared] set loading spinner',

  SELECT_ROOM = '[Shared] Select Room',
  SELECT_SUBJECT = '[Shared] Select Subject',
  SELECT_PROFESSOR = '[Shared] Select Professor',

  GET_CAPTURED_IMAGE = '[Shared] Get Captured Image',
  RESET_CAPTURED_IMAGE = '[Shared] Reset Captured Image',

  SHOW_BACK_FRONT = '[Shared] Show Back Front',
}

export const setLoadingSpinner = createAction(
  ActionTypes.SET_LOADING_SPINNER,
  props<{ status: boolean }>()
);

export const selectRoom = createAction(
  ActionTypes.SELECT_ROOM,
  props<{ data: any }>()
);

export const selectSubject = createAction(
  ActionTypes.SELECT_SUBJECT,
  props<{ data: any }>()
);

export const selectProfessor = createAction(
  ActionTypes.SELECT_PROFESSOR,
  props<{ data: any }>()
);

export const getCapturedImage = createAction(
  ActionTypes.GET_CAPTURED_IMAGE,
  props<{ data: any, captureType: any }>()
);

export const resetCapturedImage = createAction(
  ActionTypes.RESET_CAPTURED_IMAGE
);

export const showBackFront = createAction(
  ActionTypes.SHOW_BACK_FRONT,
  props<{ data: any }>()
);